module.exports = {
  pin: {
    sandbox: true,
    publishable_api_key: "pk_qwTfHEsOHTGOecxAgLkSFQ"
  },
  recaptcha: {
    site_key: "6LcenwEiAAAAAK8biCJI7pbwD3X6_AdnYz3u5y-G"
  },
};
